import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Button, Icon } from '@popmenu/common-ui';

import { Edit } from '@popmenu/web-icons';
import { useSnackbar } from '../../utils/withSnackbar';
import { useCurrentUser } from '../CurrentSessionProvider';
import { withStyles } from '../../utils/withStyles';
import userAvatarFormStyles from '../../assets/jss/shared/userAvatarFormStyles';
import updateUserUploadedAvatarMutation from '../../libs/gql/mutations/users/updateUserUploadedAvatarMutation.gql';

import Mutation from '../Mutation';
import UploadDropzone from '../../admin/shared/forms/uploader/UploadDropzone';
import { useRestaurant } from '../../utils/withRestaurant';

const UserAvatarForm = (props) => {
  const [uploading, setUploading] = useState(false);
  const currentUser = useCurrentUser();
  const restaurant = useRestaurant();
  const { showSnackbar, showSnackbarError } = useSnackbar();

  return (
    <Mutation mutation={updateUserUploadedAvatarMutation}>
      {(updateUserAvatar, { loading }) => (
        <div className={props.classes.avatarWrap}>
          <div
            className={props.classes.avatar}
            style={{ backgroundImage: `url("${currentUser.thumbnailUrl}")` }}
          >
            <div className={props.classes.avatarLabel}>
              <UploadDropzone
                accept="avatar"
                multiple={false}
                onUploaded={(uploads) => {
                  if (uploads.length > 0) {
                    // Only a single upload allowed, only need to look at the last one
                    const upload = uploads[uploads.length - 1];

                    if (upload) {
                      setUploading(!upload.popModel);

                      if (upload.popModel) {
                        const variables = {
                          uploadedAvatarId: upload.popModel.id,
                        };
                        updateUserAvatar({ variables }).then(() => {
                          showSnackbar('Your avatar was updated!');
                        }).catch((err) => {
                          showSnackbarError(err, { defaultMessage: 'update_user_avatar.failed' });
                        });
                      }
                    }
                  }
                }}
                restaurant={restaurant}
              >
                <Button
                  aria-label="Upload Avatar"
                  className={props.classes.avatarButton}
                  component="a"
                  disabled={loading || uploading}
                  startIcon={<Icon icon={Edit} />}
                  size="small"
                  variant="text"
                />
              </UploadDropzone>
            </div>
          </div>
        </div>
      )}
    </Mutation>
  );
};

UserAvatarForm.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(userAvatarFormStyles)(UserAvatarForm);
